import axiosInstance from "../../features/axiosInstance/axiosInstance";
import { PaymentResponse } from "../../features/payments/contracts/PaymentResponse";
import { ContractResponse } from "../../features/contracts/contracts/ContractResponse";
import { mapResponseToPayment } from "../../features/payments/mappers/PaymentMapper";
import { mapResponseToContract } from "../../features/contracts/mappers/ContractMapper";
import { Payment } from "../../features/payments/models/Payment";
import { Contract } from "../../features/contracts/models/Contract";

interface Paginated<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
}

const PAGE_SIZE = 100;
const MAX_PAGES = 50; // export safety cap: 5000 rows

/** All payments for the instructor (every page), for the Excel export. */
export async function fetchAllPaymentsForExport(): Promise<Payment[]> {
  return fetchAllPages<PaymentResponse, Payment>("/payments", mapResponseToPayment);
}

/** All contracts for the instructor (every page), for the Excel export. */
export async function fetchAllContractsForExport(): Promise<Contract[]> {
  return fetchAllPages<ContractResponse, Contract>("/contracts", mapResponseToContract);
}

async function fetchAllPages<TResponse, TModel>(
  path: string,
  map: (response: TResponse) => TModel,
): Promise<TModel[]> {
  const all: TModel[] = [];
  for (let page = 1; page <= MAX_PAGES; page++) {
    const response = await axiosInstance.get<Paginated<TResponse>>(path, {
      params: { page, pageSize: PAGE_SIZE },
    });
    all.push(...response.data.items.map(map));
    if (page * PAGE_SIZE >= response.data.totalCount) break;
  }
  return all;
}
